import { render, staticRenderFns } from "./DetailsIndex.vue?vue&type=template&id=f9a939b8&scoped=true"
import script from "./DetailsIndex.vue?vue&type=script&lang=js"
export * from "./DetailsIndex.vue?vue&type=script&lang=js"
import style0 from "./DetailsIndex.vue?vue&type=style&index=0&id=f9a939b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a939b8",
  null
  
)

export default component.exports